import billingContracts from './billing-contracts'
import cases from './cases'
import serviceContracts from './service-contracts'

export default {
  ...billingContracts,
  ...cases,
  ...serviceContracts
}
